import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with socket was not received within first 15 seconds.
 * @memberOf Playtech.API.events
 * @event socket-notice
 * @type {callback}
 * @param {object} detials
 * @param {number} details.requestId - Request ID.
 * @example Playtech.on('socket-notice', ({ requestId }) => { ... });
 */
export const SOCKET_NOTICE = 'socket-notice';

export const useOnSocketNotice = (eventTarget: EventTarget): void => {
    const triggerSocketNoticeEvent = useCallback((detail: {
        reason: string;
        requestId: number;
    }) => {
        const event = new CustomEvent(SOCKET_NOTICE, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('socket-notice', triggerSocketNoticeEvent);

        return () => {
            publicEventsAPIService.off('socket-notice', triggerSocketNoticeEvent);
        };
    }, [triggerSocketNoticeEvent]);
};
